import * as Blockly from 'blockly/core';

// El item "Ayuda" no abre el helpUrl: pide al shell el tutorial `Blockly_<tipo>`
// para el panel derecho. Solo `serial_print` e `inout_digital_read` declaran
// helpUrl porque son los únicos que lo tienen en prod; no es un port parcial.

const HELP_ITEM_ID = 'blockHelp';

const resolveHelpUrl = (block) => {
  const { helpUrl } = block;
  return (typeof helpUrl === 'function') ? helpUrl.call(block) : helpUrl;
};

/**
 * @param {function(string, string): void} onOpenRightPanel Recibe
 *   (tutorialCodename, workspaceId).
 */
export function registerBlockHelpItem(onOpenRightPanel) {
  const { registry } = Blockly.ContextMenuRegistry;

  if (registry.getItem(HELP_ITEM_ID)) {
    registry.unregister(HELP_ITEM_ID);
  }

  registry.register({
    id: HELP_ITEM_ID,
    scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
    weight: 7,
    displayText: () => Blockly.Msg.HELP,
    // Sin helpUrl se deshabilita en vez de esconderse (la v13 lo esconde), como en prod.
    preconditionFn: (scope) => (resolveHelpUrl(scope.block) ? 'enabled' : 'disabled'),
    callback: (scope) => {
      const { block } = scope;
      onOpenRightPanel(`Blockly_${block.type}`, block.workspace.id);
    },
  });
}

export default { registerBlockHelpItem };
